import React from 'react'
import { styled } from '@mui/material'

export const ExternalLink = styled('a')`
  align-content: baseline;
  color: ${props => props.theme.palette.blue[50]};
  display: flex;
  padding: ${props => props.padding};
  text-decoration: none;

  &:hover {
    color: ${props => props.theme.palette.blue[35]};
  }
`

export const Link = styled('p')`
  align-content: baseline;
  font-size: 16px;
  color: ${props => props.theme.palette.gray[50]};
  display: flex;
  padding-top: 24px;
  text-decoration: underline;
  border: none;
  background-color: transparent;
  cursor: pointer;
  &:hover {
    color: ${props => props.theme.palette.gray[35]};
  }
`

export const Strong = styled('span')`
  font-weight: bold;
`

export const SubHeadingWrapper = styled(({ alignItems, children, ...props }) => <div {...props}>{children}</div>)`
  align-items: ${props => props.alignItems};
  display: flex;
`
